import React from 'react';
import { AuthLayout } from '../components/AuthLayout';
import { LoginForm } from '@/features/authentication/presentation/components/LoginForm';
import { useLoginBridge } from '@/features/authentication/presentation/composables/bridges/LoginBridge';

/**
 * Tela de login — layout + formulário; fluxo de auth vem do `useLoginBridge`.
 */
export const LoginScreen: React.FC = () => {
  const loginFormProps = useLoginBridge();

  return (
    <AuthLayout
      title="Entrar"
      subtitle="Faça login com seu número de celular ou rede social para continuar."
      footer={
        <p className="text-center text-sm text-white/80">
          Não tem conta? É só entrar — pedimos o restante depois.
        </p>
      }
    >
      <LoginForm {...loginFormProps} />
    </AuthLayout>
  );
};
